const tableTitle = {
  placeholder: 'Buscar'
};

export default tableTitle;
